import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "POST" }
  }

  async fire(event) {
    // Submit via a real form so Turbo handles the redirect + flash. The
    // Plutonium interaction dispatcher reads attributes from
    // params[:interaction][...], so the approval token has to be nested
    // under that key.
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const form = document.createElement("form")
    form.method = this.methodValue.toLowerCase() === "post" ? "post" : "post"
    form.action = this.urlValue
    form.style.display = "none"
    if (this.methodValue.toUpperCase() !== "POST") {
      const m = document.createElement("input")
      m.name = "_method"
      m.value = this.methodValue.toLowerCase()
      form.appendChild(m)
    }
    const fields = {
      "interaction[approval_token]": event.detail.approvalToken,
      "authenticity_token": csrf || ""
    }
    for (const [k, v] of Object.entries(fields)) {
      const input = document.createElement("input")
      input.name = k
      input.value = v
      form.appendChild(input)
    }
    document.body.appendChild(form)
    form.requestSubmit()
  }
}
